import React from 'react';
import { HealthScoreContextLine, HealthScorePeriodDirection } from './healthScoreContext';

function ScorePeriodMark({ direction }: { direction: HealthScorePeriodDirection }): React.ReactElement {
  const label = direction === 'up' ? 'Up' : direction === 'down' ? 'Down' : 'No change';
  const color = direction === 'up'
    ? 'text-lime-green'
    : direction === 'down'
      ? 'text-error-red'
      : 'text-current';

  return (
    <svg
      viewBox="4 4 24 26"
      className={`block h-[1em] w-[0.92em] shrink-0 ${color} ${direction === 'down' ? 'rotate-180' : ''}`}
      role="img"
      aria-label={label}
    >
      {direction === 'flat' ? (
        <path
          d="M6 16h20"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
      ) : (
        <path
          d="M16 27V7M16 7l-8 8M16 7l8 8"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}

export function HealthScoreContextList({
  lines,
  className,
}: {
  lines: HealthScoreContextLine[];
  className?: string;
}): React.ReactElement {
  return (
    <ul className={className}>
      {lines.map((line) => (
        <li key={line.key} className="flex items-center justify-center gap-1">
          {line.direction ? <ScorePeriodMark direction={line.direction} /> : null}
          <span>{line.text}</span>
        </li>
      ))}
    </ul>
  );
}
